/* eslint-disable no-new */

export class Toggle {
    constructor({
        source,
        target = document.querySelector(source.dataset.target),
        sourceClass = 'toggled',
        targetClass = 'toggled',
        callBack = null,
    }) {
        this.source = source;
        this.target = target;
        this.sourceClass = sourceClass;
        this.targetClass = targetClass;
        this.callBack = callBack;

        if (!this.source) return;

        this.source.addEventListener('click', (e) => {
            const stopRedirect = source.tagName === 'A' && source.classList.contains('js-toggle');
            if (stopRedirect) e.preventDefault();
            this.toggleClasses();

            if (typeof (Event) === 'function') {
                this.source.dispatchEvent(new Event('e7Toggle'));
            } else {
                const event = document.createEvent('Event');
                event.initEvent('e7Toggle', true, true);
                this.source.dispatchEvent(event);
            }

            if (this.callBack) this.callBack();
        });
    }

    toggleClasses() {
        if (this.sourceClass) this.source.classList.toggle(this.sourceClass);
        if (this.targetClass && this.target) this.target.classList.toggle(this.targetClass);
    }
}

export default(() => {
    const toggles = Array.from(document.querySelectorAll('.js-toggle'));
    toggles.forEach((el) => {
        new Toggle({ source: el });
    });
})();
